module.exports = __webpack_public_path__ + "static/portfolio_gallery_10-b35e8c119ad4c680b8928488dee20979.jpg";